import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Container } from '@mui/material';

import { IContainer } from "../../../types/container";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import { Icons } from "../../icons";
import ContainerDetailsForm from "../../forms/containerDetailsForm";

const blankContainer: IContainer = {
	id: undefined,
	name: "",
	weight: 0,
	length: 0,
	width: 0,
	height: 0,
	fillsPosition: false,
	isActive: true
};

const ContainerAdd = () => {
	const userContext = useUserContext();

	const [formFields, setFormFields] = useState<IContainer>(blankContainer);

	useEffect(() => {
	}, [])

	const reset = () => {
		setFormFields(JSON.parse(JSON.stringify(blankContainer)));
	}

	return (
		<div className="hwi-container-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageContainers}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/container">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Container
						</div>
					</section>
					<section className="management-page-form">
						<ContainerDetailsForm action="add" details={formFields} reloadData={reset} ></ContainerDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default ContainerAdd;